import styled from "styled-components";
import { mobileAuthSideContainer, mobileAuthMainContainer } from "../../../styles/authShellMixins";

export const MainContainer = styled.div`
  position: relative;
  display: flex;
  //flex-direction: column;
  //align-items: center;
  width: 100%;
  height: 100%;
  background: var(--app-bg-gradient);
  background-size: 400% 400%;
  font-family: "Inter", "Helvetica Neue", sans-serif;
  overflow-x: hidden;

  ${mobileAuthMainContainer}
`;

export const SideContainer = styled.div`
  scrollbar-width: none; 
  overflow-y: auto; 
  overflow-x: hidden; 
  position: relative; 
  height: 100vh; 
  min-height: 100vh; 
  width: ${({ collapsed }) => (collapsed ? "calc(100% - 6vw)" : "calc(100% - 15vw)")};
  margin: auto;
  transition: margin-left 0.5s ease-in-out, width 0.5s ease-in-out; 
  display: flex;
  flex-direction: column;
  align-items: center; /* Centraliza horizontalmente */
  justify-content: flex-start; /* Alinha no topo */

  &::-webkit-scrollbar {
    display: none; /* Remove scrollbar no Chrome/Safari */
  }

  ${mobileAuthSideContainer}
`;

// Wrapper do conteúdo
export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1200px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto; /* Centraliza horizontalmente */
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
   background: linear-gradient(135deg, var(--accent-secondary) 0%, var(--accent) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 2rem 0;
  text-shadow: 0 4px 20px color-mix(in srgb, var(--accent-secondary) 30%, transparent);
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const HeaderSection = styled.header`
  text-align: center;
  margin-bottom: 1rem;
  position: relative;
`;

export const FormContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  padding: 2.5rem;
  border-radius: 20px;

 
  margin: auto;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.26vw;
  width: 50%;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.26vw;
  width: 50%;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const FormCard = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 1.5rem 1.75rem 1.75rem;
  border-radius: 16px;
  border: 1px solid var(--border-default);
  background: var(--surface-overlay, var(--surface-1));
  box-shadow: 0 8px 28px color-mix(in srgb, var(--text-primary) 6%, transparent);
`;

export const FormHint = styled.p`
  margin: 0 0 1.25rem;
  color: var(--text-muted, var(--text-secondary));
  font-size: 0.95rem;
  line-height: 1.5;
  max-width: 70ch;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 0.5rem;
  min-height: auto; /* Remover altura fixa */
  padding: 0.25rem 0;
`;

export const Label = styled.label`
  color: var(--text-heading);
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 0.5rem;
  display: block;
  position: relative;
  z-index: 2;
`;

export const ShowInput = styled.input`
  width: 23.2vw;
  height: 1.2vw;
  padding: 0.8vw 0.8vw;
  border: 2px solid var(--border-default);
  border-radius: 12px;
  font-size: 14px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-primary);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 2;

  &::placeholder {
    color: var(--text-muted);
  }

  &:focus {
    border-color: var(--accent);
    background: var(--input-bg-focus);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    height: auto;
    min-height: 44px;
    padding: 0.7rem 0.85rem;
    font-size: 16px;
    box-sizing: border-box;
  }
`;

export const StyledSelect = styled.select`
  width: 25vw;
  height: 3vw;
  padding: 0.8vw 0.8vw;
  padding-right: 50px; // Aumenta o espaço para a seta + margem
  border: 2px solid var(--border-default);
  border-radius: 12px;
  font-size: 14px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-primary);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  cursor: pointer;
  position: relative;
  z-index: 2;
  
  // Remove as propriedades de direção RTL
  text-align: left;
  direction: ltr;

  // Custom arrow (seta personalizada) na direita com margem
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23dbfb8e'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 20px center; // Seta na direita com margem
  background-size: 20px;

  option {
    background: var(--surface-overlay);
    color: var(--text-primary);
  }

  &:focus {
    border-color: var(--accent);
    background: var(--input-bg-focus);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    padding-right: 45px;
    background-position: right 15px center;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
  position: relative;
  z-index: 2;
  width: 100%;
  padding: 0.5rem 0;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const StyledButton = styled.button`
  background: ${props => props.secondary 
    ? 'var(--input-bg)' 
    : 'var(--accent-secondary-soft)'};
  border: 2px solid ${props => props.secondary 
    ? 'var(--border-subtle)' 
    : 'var(--border-default)'};
  border-radius: 16px;
  color: ${props => props.secondary 
    ? 'var(--text-primary)' 
    : 'var(--text-heading)'};
  cursor: pointer;
  padding: 12px 24px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  min-width: 140px;
  min-height: 44px;
  z-index: 2;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, 
      ${props => props.secondary 
        ? 'var(--input-bg) 0%, var(--surface-glass) 100%' 
        : 'var(--accent-secondary-soft) 0%, var(--accent-soft) 100%'}
    );
    opacity: 0;
    transition: opacity 0.4s ease;
    border-radius: 14px;
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 14px;
    background: transparent;
    box-shadow: ${props => props.secondary 
      ? 'var(--shadow-sm)' 
      : '0 6px 15px var(--accent-soft)'};
    opacity: 0;
    transition: opacity 0.4s ease;
    z-index: -1;
  }

  &:hover {
    transform: translateY(-3px);
    border-color: ${props => props.secondary 
      ? 'var(--text-muted)' 
      : 'var(--accent)'};
    color: var(--text-primary);

    &::before {
      opacity: 1;
    }

    &::after {
      opacity: 1;
    }
  }

  &:active {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  @media screen and (max-width: 768px) {
    min-width: 120px;
    padding: 10px 20px;
  }
`;

export const FileInputButton = styled.label`
  width: 23.2vw;
  height: 1.2vw;

  padding: 0.8vw 0.8vw;
  border: 2px solid var(--border-default);
  border-radius: 12px;
  font-size: 14px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-primary);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  cursor: pointer;
  position: relative;
  z-index: 2;
  
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: var(--text-secondary);
    background: var(--input-bg-focus);
  }

  &:focus {
    border-color: var(--accent);
    background: var(--input-bg-focus);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    height: auto;
    padding: 12px;
  }
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const ArquivoAtual = styled.label`
  font-size: 80%;
  color: var(--text-heading);
  display: block;
  margin-bottom: 2.5vh;
`;

export const ArquivoEscolhido = styled.label`
  font-size: 100%;
  color: var(--danger);
  display: block;
  margin-bottom: 2.5vh;
`;

// Adicione estas estilizações no seu arquivo styles.js
export const CollapsedContainer = styled.div`
  margin: 10px 0;
  border: 1px solid var(--border-subtle);
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: var(--accent);
    box-shadow: var(--shadow-sm);
  }
`;

export const CollapsedPreview = styled.div`
  padding: 15px;
  background-color: var(--surface-2);
`;

export const PreviewHeader = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: var(--text-primary);
`;

export const PreviewContent = styled.div`
  margin-top: 10px;
  padding-left: 30px;
`;

export const ExpandButton = styled.span`
  font-size: 12px;
  color: var(--text-muted);
  transition: transform 0.3s ease;
`;


// Estilos para a prévia da área salva (modo colapsado)
export const AreaPreviewContainer = styled.div`
  margin: 10px 0;
  border: 1px solid var(--border-default);
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  background: var(--input-bg);
  backdrop-filter: blur(10px);
  height: 50px; /* Altura fixa para uma linha */
  display: flex;
  align-items: center;
  padding: 0 15px;

  &:hover {
    border-color: var(--accent);
    background: var(--input-bg-focus);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px var(--accent-soft);
  }
`;

export const AreaPreviewContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 14px;
  color: var(--text-primary);
  gap: 15px;
`;

export const AreaPreviewCol = styled.div`
  flex: ${props => props.flex || 1};
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0; /* Permite que o texto seja truncado */
`;

export const AreaNumber = styled.span`
  font-weight: bold;
  color: var(--text-heading);
  min-width: 50px;
`;

export const AreaName = styled.span`
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
`;

export const PreviewLabel = styled.span`
  color: var(--text-heading);
  font-size: 12px;
  margin-right: 4px;
`;

export const PreviewValue = styled.span`
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SavedIndicator = styled.span`
  color: var(--accent);
  font-weight: bold;
  font-size: 12px;
  background: var(--accent-soft);
  padding: 4px 8px;
  border-radius: 10px;
  border: 1px solid var(--accent);
  white-space: nowrap;
`;

export const ExpandIcon = styled.span`
  color: var(--text-heading);
  font-size: 12px;
  transition: transform 0.3s ease;
  margin-right: 8px;
  
  ${AreaPreviewContainer}:hover & {
    color: var(--accent);
  }
`;